<form class="release" [formGroup]="releaseForm" (ngSubmit)="release()">
  <header class="release__header">
    <h3 class="release__header__title">
      {{ "dialogs.release.title" | translate }}
    </h3>
    <button
      *ngIf="!loading"
      class="release__header__close-btn"
      [mat-dialog-close]="false"
      type="button"
    ></button>
  </header>
  <section
    class="release__section release__section_token"
    *ngIf="dialogParams.singleCertificate"
    id="qr-section"
  >
    <div class="release__section_token__print-container">
      <qrcode
        style="width: 150px"
        matTooltip="{{ 'dialogs.release.qrCodeTooltip' | translate }}"
        [matTooltipPosition]="'above'"
        [qrdata]="
          getCertificatePreviewLink(dialogParams.singleCertificate)!
        "
        elementType="svg"
        [cssClass]="'qr-styles'"
        (click)="copyImage(qrUrl)"
        [width]="150"
      ></qrcode>
      <qrcode
        hidden
        [qrdata]="
          getCertificatePreviewLink(dialogParams.singleCertificate)!
        "
        elementType="img"
        (qrCodeURL)="qrUrl = $event"
        [width]="500"
      ></qrcode>
      <div id="print-qr" hidden>
        <img
          [src]="qrUrl"
          style="
            display: block;
            width: 100%;
            min-height: 500px;
            object-fit: contain;
            object-position: center;
          "
          alt="qr-img"
        />
      </div>
      <button
        type="button"
        mat-flat-button
        color="primary"
        ngxPrint
        printSectionId="print-qr"
        printTitle="{{
          'dialogs.release.tokenTitle'
            | translate
              : { certificateName: dialogParams.singleCertificate.name }
        }}"
      >
        {{ "dialogs.release.printQR" | translate }}
      </button>
    </div>
    <div
      class="release__section_token__text-block"
      matTooltip="{{ 'dialogs.release.tokenTooltip' | translate }}"
      [matTooltipPosition]="'above'"
      (click)="copyText(dialogParams.singleCertificate!.token!)"
    >
      <h3 class="release__section_token__title">
        {{
        "dialogs.release.tokenTitle"
          | translate
          : {certificateName: dialogParams.singleCertificate.name}
        }}
      </h3>
      <p>
        {{ dialogParams.singleCertificate!.token }}
      </p>
    </div>
  </section>
  <section class="release__section">
    <div class="release__input-container">
      <span class="release__input-title">
        <span>
          {{ "dialogs.release.email.title" | translate }}
        </span>
        <span class="release__input-title__comment">{{
          "dialogs.release.email.subtitle" | translate
          }}</span>
      </span>
      <ling-input
        id="email-input"
        type="email"
        formControlName="sendTo"
        placeholder="{{ 'dialogs.release.email.placeholder' | translate }}"
        [disabledInput]="loading"
      ></ling-input>
    </div>
  </section>
  <section class="release__section" id="advanced-section">
    <h3
      class="release__section_collapsable__header"
      (click)="detailsExpanded$.next(!detailsExpanded$.value)"
    >
      {{ "dialogs.release.advancedOptionsToggle" | translate }}
      <mat-icon>{{
        (detailsExpanded$ | async) ? "expand_less" : "expand_more"
        }}</mat-icon>
    </h3>
    <div
      class="release__section_collapsable__content"
      [@detailExpand]="detailsExpanded$ | async"
    >
      <div class="release__input-container">
        <span class="release__input-title">
          <span>
            {{ "dialogs.release.claimTime.title" | translate }}
          </span>
          <span class="release__input-title__comment">{{
            "dialogs.release.claimTime.subtitle" | translate
            }}</span>
        </span>
        <div class="release__counters">
          <ling-input
            formControlName="days"
            type="counter"
            counterLabel="{{ 'dialogs.release.claimTime.days' | translate }}"
            [disabledInput]="loading"
            [counterLimit]="maxDays"
          ></ling-input>
          <ling-input
            formControlName="hours"
            type="counter"
            counterLabel="{{ 'dialogs.release.claimTime.hours' | translate }}"
            [disabledInput]="loading"
            [counterLimit]="maxHours"
          ></ling-input>
          <ling-input
            formControlName="minutes"
            type="counter"
            counterLabel="{{ 'dialogs.release.claimTime.minutes' | translate }}"
            [disabledInput]="loading"
            [counterLimit]="maxMinutes"
          ></ling-input>
        </div>
      </div>
    </div>
  </section>
  <mat-divider></mat-divider>
  <section
    class="release__section release__section_summary"
    id="summary-section"
  >
    <div *ngIf="isPaymentNeeded" class="release__section_summary__price">
      <span>{{ "dialogs.release.priceFor" | translate }}</span>
      <span>=</span>
      <ling-credits [credits]="this.settings!.releasePrice!"></ling-credits>
    </div>
    <button
      mat-flat-button
      color="primary"
      class="release__submit-button"
      type="submit"
      *ngIf="!loading"
    >
      <div class="release__submit-button__content">
        {{ buttonText }}
        <ling-credits
          *ngIf="isPaymentNeeded"
          [credits]="
            this.settings!.releasePrice! *
            (this.dialogParams.certArray?.length ?? 1)
          "
          [showName]="false"
        ></ling-credits>
      </div>
    </button>
    <mat-progress-spinner
      *ngIf="loading"
      [diameter]="30"
      mode="indeterminate"
    ></mat-progress-spinner>
  </section>
</form>
